import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthTokenRetrieve, LoginButton, LogoutButton } from "../Utility/AuthTokenRetrieve";
import "../Food/RecipeList.css";
import "./FoodDiary.css";
import { fetchDiaryMeals, fetchDiarySymptoms } from "./FoodDiaryShared";

const FoodDiaryHome = () => {
  const [shouldShow, setShouldShow] = useState();
  const [meals, setMeals] = useState([]);
  const [symptoms, setSymptoms] = useState([]);
  const [loading, setLoading] = useState(true);
  const { shouldShow: shouldShowGoogle } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(shouldShowGoogle);
  }, [shouldShowGoogle]);

  const accessToken = localStorage.getItem("lesterAccessToken") || "";

  useEffect(() => {
    if (!shouldShow || !accessToken) {
      setLoading(false);
      return;
    }

    setLoading(true);
    Promise.all([fetchDiaryMeals(accessToken), fetchDiarySymptoms(accessToken)])
      .then(([mealData, symptomData]) => {
        setMeals(mealData || []);
        setSymptoms(symptomData || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [shouldShow, accessToken]);

  if (!shouldShow) {
    return (
      <div className="searchBarDiv formViewWrapper FoodDiaryLogin">
        <h2>Food diary</h2>
        <p>Sign in to view and manage private meal and symptom entries.</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  return (
    <div className="FoodDiaryPage">
      <div className="searchBarDiv formViewWrapper FoodDiaryIntro">
        <div>
          <h2 className="FoodDiaryTitle">Food diary</h2>
          <p className="FoodDiarySubtitle">
            A private place to track meals and symptoms without crowding the screen.
          </p>
        </div>
        <LogoutButton setShouldShow={setShouldShow}></LogoutButton>
      </div>

      <div className="FoodDiaryGrid">
        <div className="shoppingListDiv FoodDiaryPanel FoodDiaryActionPanel">
          <h3>Quick actions</h3>
          <p>Choose the entry type you want to add.</p>
          <div className="FoodDiaryActionRow">
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/add-meal">
              Add Meal
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/add-symptom">
              Add Symptom
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/meals">
              Meal History
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/symptoms">
              Symptom History
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/bowel-events">
              Bowel Events
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/daily-context">
              Daily Context
            </Link>
            <Link className="summaryButton FoodDiaryLinkButton" to="/food-diary/summary">
              Summary
            </Link>
          </div>
        </div>
      </div>

      {loading ? <div className="shoppingListDiv">Loading diary data...</div> : null}

      <div className="FoodDiaryGrid">
        <div className="shoppingListDiv FoodDiaryPanel">
          <h3>Recent meals</h3>
          {meals.length ? (
            meals.map((meal) => (
              <div key={meal.id} className="FoodDiaryHistoryRow">
                <div>
                  <strong>{meal.mealType}</strong>
                  <div>{meal.eatenAt}</div>
                </div>
                <div className="FoodDiaryHistoryMeta">
                  <span>{meal.itemCount} items</span>
                  <span>{meal.ingredientCount} ingredients</span>
                </div>
              </div>
            ))
          ) : (
            <p>No meals logged yet.</p>
          )}
        </div>

        <div className="shoppingListDiv FoodDiaryPanel">
          <h3>Recent symptoms</h3>
          {symptoms.length ? (
            symptoms.map((symptom) => (
              <div key={symptom.id} className="FoodDiaryHistoryRow">
                <div>
                  <strong>{symptom.symptomType}</strong>
                  <div>{symptom.startedAt}</div>
                </div>
                <div className="FoodDiaryHistoryMeta">
                  <span>Severity {symptom.severity}</span>
                  <span>{symptom.endedAt ? "Ended" : "Active"}</span>
                </div>
              </div>
            ))
          ) : (
            <p>No symptoms logged yet.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FoodDiaryHome;
